import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    addFromColumn,
    sortCurrency, toCurrency
} from '../shared/functions';
import {setDefaultTableSort, getTableState, filterCaseInsensitive} from '../shared/tableFunctions';
import {convertStartAndEndDatesForFile} from '../shared/printFunctions';
import ReactTable from 'react-table';
import {CSVLink} from 'react-csv';
import '../shared/react-table.css';
import {commonStyles} from '../shared/styles';
import {tableStyles} from '../shared/styles-table';
import FlatButton from "material-ui/FlatButton";
import ExportIcon from 'material-ui/svg-icons/navigation/arrow-downward';
import VIPSalesLogsIcon from 'material-ui/svg-icons/action/receipt';

/**
 * Class for displaying Sales Logs Summary in a table
 *
 */
class VIPTrendsSalesLogsTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            summaryList: [],
            summaryTableData: [],
            summaryTableHeaders: [
                {label: 'ID', key: 'sale_seq'},
                {label: 'Processed', key: 'transaction_date_string'},
                {label: 'Subtotal', key: 'initial_net'},
                {label: 'Tax', key: 'initial_tax'},
                {label: 'Total', key: 'initial_total'},
                {label: 'Location', key: 'location'},
                {label: 'Register', key: 'register'},
                {label: 'User', key: 'user'},
                {label: 'Mode', key: 'mode'},
                {label: 'Version', key: 'version'}
            ],
        };
        this.handleExportClick = this.handleExportClick.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handleSortChange = this.handleSortChange.bind(this);
    }

    componentWillMount() {
        this.processData(this.props.listData);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.listData !== this.props.listData) {
            this.setState({
                summaryList: nextProps.listData,
                summaryTableData: nextProps.listData
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.listData !== this.props.listData) {
            this.processData(this.props.listData);
        }
    }

    /* Data Processing ------------------------------ */

    /**
     * Set data for use by table
     *
     * @param listData
     */
    processData(listData) {
        this.setState({
            summaryList: listData,
            summaryTableData: listData
        });
    }

    /* Table Building ------------------------------ */

    /**
     * Update selected table data based on sort
     *
     * @param event
     * @param table
     */
    handleSortChange(event, table) {
        const tableData = getTableState(table);
        this.setState({
            summaryTableData: tableData
        });
    }

    /**
     * Update selected table data based on filter and lift state
     *
     * @param event
     * @param table
     */
    handleFilterChange(event, table) {
        const tableData = getTableState(table);
        this.setState({
            summaryTableData: tableData
        });
    }

    /**
     * Handle event to retrieve current state of table data
     *
     * @param event
     */
    handleExportClick = (event) => {
        // CSVLink handles generation and export of CSV
    };

    /* Table Display ------------------------------ */

    render() {

        const {
            endDate,
            logSelectFunction,
            startDate,
            system,
            tableKey,
            tableLabel
        } = this.props;

        const {
            summaryList,
            summaryTableData,
            summaryTableHeaders
        } = this.state;

        const dateString = convertStartAndEndDatesForFile(startDate, endDate);
        const defaultSort = setDefaultTableSort('sale_seq');

        // Headers and columns for ReactTable
        const tableColumns = [
            {
                Header: '',
                columns: [
                    {
                        Header: 'Id',
                        accessor: 'sale_seq',
                        style: tableStyles.wrapText,
                        Cell: props => (
                            <a style={tableStyles.linkDefault}
                               onClick={(e) => logSelectFunction(e, props.row.sale_seq)}
                            >
                                {props.row.sale_seq}
                            </a>
                        ),
                        width: 210
                    },
                    {
                        Header: 'Processed',
                        accessor: 'transaction_date',
                        Cell: props => (
                            <span>{props.row.transaction_date_string}</span>
                        ),
                        width: 150
                    },
                    {
                        Header: '',
                        accessor: 'transaction_date_string',
                        style: tableStyles.hide,
                        headerStyle: tableStyles.hide
                    },
                    {
                        Header: 'Subtotal',
                        accessor: 'initial_net',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'initial_net'))}
                            </span>
                        )
                    },
                    {
                        Header: 'Tax',
                        accessor: 'initial_tax',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'initial_tax'))}
                            </span>
                        )
                    },
                    {
                        Header: 'Total',
                        accessor: 'initial_total',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'initial_total'))}
                            </span>
                        )
                    },
                    {
                        Header: 'Register',
                        accessor: 'register',
                        style: tableStyles.tdMax,
                    },
                    {
                        Header: 'User',
                        accessor: 'user',
                        style: tableStyles.tdMax,
                    },
                    {
                        Header: 'Mode',
                        accessor: 'mode',
                        style: tableStyles.tdMax,
                    },
                    {
                        Header: 'Version',
                        accessor: 'version',
                        width: 130
                    }
                ]
            }
        ];

        return (
            <div>
                {summaryList.length > 0 &&
                <div className="reports-table-container">

                    {/* Table Header: Sales Logs */}
                    <div className="reports-table-title table-table-header">
                        <div className="btn-report-container report-header-button-container">
                            {/* Export VIP Trends - Sales Logs */}
                            <FlatButton
                                primary
                                type="button"
                                label=""
                                style={commonStyles.headerButton}
                            >
                                <ExportIcon style={commonStyles.headerButtonIcon}/>
                                <CSVLink
                                    data={summaryTableData}
                                    headers={summaryTableHeaders}
                                    filename={'VIP-Trends-Sales-Logs-' + system + '-' + dateString + '.csv'}
                                    onClick={(e) => this.handleExportClick(e)}
                                    target="_blank"
                                    style={commonStyles.headerButtonLink}
                                >
                                    Export Sales Logs
                                </CSVLink>
                            </FlatButton>
                        </div>
                        <h3 className="table-table-header-title">
                            <VIPSalesLogsIcon style={commonStyles.summaryIcon}/>
                            <span>{tableLabel}</span>
                        </h3>
                    </div>

                    {/* Table: Sales Logs */}
                    <ReactTable
                        key={`table-sales-logs-${tableKey}`}
                        data={summaryList}
                        columns={tableColumns}
                        defaultPageSize={5}
                        showPagination={true}
                        defaultSorted={defaultSort}
                        filterable
                        defaultFilterMethod={filterCaseInsensitive}
                        onSortedChange={(e) => this.handleSortChange(e, this.salesLogsReactTable)}
                        onFilteredChange={(e) => this.handleFilterChange(e, this.salesLogsReactTable)}
                        ref={(r) => this.salesLogsReactTable = r}
                        resizable={false}
                        minRows={1}
                        className="-striped overflow no-print"
                    />
                    <ReactTable
                        key={`table-sales-logs-print-${tableKey}`}
                        data={summaryTableData}
                        columns={tableColumns}
                        defaultPageSize={10000}
                        showPagination={false}
                        defaultSorted={defaultSort}
                        filterable
                        resizable={false}
                        minRows={1}
                        className="print-only"
                    />
                </div>
                }
            </div>
        )
    }
}

VIPTrendsSalesLogsTable.propTypes = {
    addField: PropTypes.bool,
    allowLoyaltySelection: PropTypes.bool,
    endDate: PropTypes.string,
    listData: PropTypes.array,
    logSelectFunction: PropTypes.func,
    startDate: PropTypes.string,
    system: PropTypes.string,
    tableKey: PropTypes.string,
    tableLabel: PropTypes.string
};

VIPTrendsSalesLogsTable.defaultProps = {
    addField: true,
    allowLoyaltySelection: true,
    endDate: null,
    startDate: null,
    tableKey: 'sales-logs',
    tableLabel: 'Sales Logs'
};

export default VIPTrendsSalesLogsTable;



// WEBPACK FOOTER //
// ./src/Fuse/components/VIPTrendsSalesLogsTable.js